import React from 'react';
import { DataGrid as MuiDataGrid, type GridColDef, type GridRowsProp } from '@mui/x-data-grid';
import { Box } from '@mui/material';

export interface DataGridProps {
  columns: GridColDef[];
  rows: GridRowsProp;
  loading?: boolean;
  pageSize?: number;
  height?: number;
  onEdit?: (id: string | number) => void;
  onRowClick?: (params: any) => void;
  getRowId?: (row: any) => string | number;
  pagination?: boolean;
}

const DataGrid: React.FC<DataGridProps> = ({
  columns,
  rows,
  loading = false,
  pageSize = 10,
  height = 550,
  onRowClick,
  getRowId,
  pagination = true,
}) => {
  return (
    <Box
      sx={{
        height,
        width: '100%',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        backgroundColor: (theme) => theme.palette.mode === 'light' ? '#ffffff' : '#1f2937',
      }}
    >
      <MuiDataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        getRowId={getRowId}
        onRowClick={onRowClick}
        hideFooter={!pagination}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize },
          },
        }}
        pageSizeOptions={pagination ? [5, 10, 25] : []}
        disableRowSelectionOnClick
        rowHeight={45}
        columnHeaderHeight={45}
        slotProps={{
          pagination: {
            labelRowsPerPage: 'Filas por página',
          },
        }}
        sx={{
          border: 'none',
          backgroundColor: "#fff",
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: "#f9fafb",
            color: "#374151",
            fontSize: "0.75rem",
            textTransform: "uppercase",
          },
          '& .MuiDataGrid-columnHeader': {
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderBottom: '1px solid #e5e7eb',
            padding: '6px 16px',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 600,
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#f3f4f6",
            cursor: "pointer",
          },
          '& .MuiDataGrid-cell': {
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderBottom: '1px solid #e5e7eb',
            padding: '5px 16px',
            fontSize: '0.875rem',
            lineHeight: 1.5,
            fontWeight: 400,
          },
          '& .MuiDataGrid-cell:hover': {
            color: 'primary.main',
            cursor: onRowClick ? 'pointer' : 'default',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnSeparator': {
            visibility: 'visible',
            color: '#e5e7eb',
          },
          '& .MuiIconButton': {
            padding: '4px',
            '& .MuiSvgIcon': {
              fontSize: '1rem',
            },
          },
        }}
      />
    </Box>
  );
};

export default DataGrid;
